import { isEmpty } from 'lodash'
import { defaultExportMenu, getPieSeries } from '../helpers'

export default ({ config, data, color }) => {
  const { labelColor } = color
  const {
    series,
    removeLegend,
    pieRadius,
    innerRadius,
    paddingTop,
    centerTitle,
    centerTitleSize,
    legendPosition = 'bottom',
    exportingMenu,
    disabledAnimations = false,
    ...restConfig
  } = config
  const pieseries = [
    getPieSeries({
      series,
      otherConfig: {
        color,
        centerTitle,
        centerTitleSize,
        disabledAnimations,
        ...restConfig
      }
    })
  ]

  const pieConf = {
    type: 'PieChart',
    radius: pieRadius,
    innerRadius,
    data,
    series: pieseries,
    legend: {
      itemContainers: {
        paddingTop: 0,
        paddingBottom: 5
      },
      position: legendPosition,
      valueLabels: {
        template: {
          type: 'Label',
          disabled: true
        }
      },
      useDefaultMarker: true,
      labels: {
        text: '{category}',
        fill: labelColor,
        fontSize: 12,
        marginLeft: 0,
        paddingBottom: 8
      },
      contentAlign: 'left',
      markers: {
        children: [
          {
            width: 12,
            height: 12
          }
        ]
      },
      maxHeight: 55,
      scrollable: true
    }
  }

  if (removeLegend) {
    delete pieConf.legend
  }

  // Export menu
  if (exportingMenu && exportingMenu.enabled) {
    if (isEmpty(exportingMenu.config)) {
      pieConf.exporting = defaultExportMenu
    } else {
      pieConf.exporting = exportingMenu.config
    }
  }

  return pieConf
}
